import rules from "../../rules";

const check = (role, action, data) => {
	if (role === "admin") return true;

	const dataPermissions = Array.isArray(data?.permissions)
		? data.permissions
		: [];
	if (dataPermissions.includes(action)) return true;

	try {
		const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
		if (storedUser?.profile === "admin") return true;
		if (Array.isArray(storedUser?.permissions)) {
			return storedUser.permissions.includes(action);
		}
	} catch {
		// Keep compatibility with the static rule fallback below.
	}

	const permissions = rules[role];
	if (!permissions) {
		// role is not present in the rules
		return false;
	}

	const staticPermissions = permissions.static;

	if (staticPermissions && staticPermissions.includes(action)) {
		// static rule not provided for action
		return true;
	}

	const dynamicPermissions = permissions.dynamic;

	if (dynamicPermissions) {
		const permissionCondition = dynamicPermissions[action];
		if (!permissionCondition) {
			// dynamic rule not provided for action
			return false;
		}

		return permissionCondition(data);
	}
	return false;
};

const Can = ({ role, perform, data, yes, no }) =>
	check(role, perform, data) ? yes() : no();

Can.defaultProps = {
	yes: () => null,
	no: () => null,
};

export { Can };
